var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3C11.448 3 11 3.448 11 4V17.0703L7.13672 13.207C6.74572 12.816 6.11266 12.816 5.72266 13.207L5.63672 13.293C5.24572 13.684 5.24572 14.317 5.63672 14.707L11.293 20.3633C11.684 20.7543 12.317 20.7543 12.707 20.3633L18.3633 14.707C18.7543 14.316 18.7543 13.683 18.3633 13.293L18.2773 13.207C17.8863 12.816 17.2533 12.816 16.8633 13.207L13 17.0703V4C13 3.448 12.552 3 12 3Z"
  })));
}
export default SvgArrowDownreact;